import type { WarningTier } from '@/domain/feedingDashboard';

import type { KpiTone } from '../feedingChartColors';

import styles from './PenComparisonTable.module.scss';

/**
 * The warning state on a breached bFCR or RGI cell. Two tiers, both the portal's alert
 * tokens: past the target, then past the configured caution margin as well.
 */
export function warningCellClass(tier: WarningTier): string | undefined {
    if (tier === 'warning') return styles.breachWarning;
    if (tier === 'critical') return styles.breachCritical;
    return undefined;
}

/**
 * The bands outside the four IPS triggers (feed vs plan, SFR, confidence interval) keep
 * their levels but in the information palette, so a pen that meets its targets can never
 * look like it is in the warning state (IPS 2.6.2). In band stays unmarked. Pellet
 * fallthrough has its own classes, `pelletCellClass`.
 */
export function infoCellClass(tone: KpiTone): string | undefined {
    if (tone === 'warning') return styles.info;
    if (tone === 'alert') return styles.infoStrong;
    return undefined;
}

/**
 * Pellet fallthrough's elevated and high bands, drawn as the warning tiers are drawn but
 * under their own classes: pellet fallthrough never puts a pen in the warning state (O7).
 */
export function pelletCellClass(tone: KpiTone): string | undefined {
    if (tone === 'warning') return styles.pelletElevated;
    if (tone === 'alert') return styles.pelletHigh;
    return undefined;
}
